import { render, staticRenderFns } from "./PersonnelRecordDetailCardAssignments.vue?vue&type=template&id=71be3386"
import script from "./PersonnelRecordDetailCardAssignments.vue?vue&type=script&lang=js"
export * from "./PersonnelRecordDetailCardAssignments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports